/**
 *  @class
 *  @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    this.parent = this.closest(".product-recommendations--parent");
    this.recommendationsCarousel = null;

    Flickity.prototype._createResizeClass = function () {
      this.element.classList.add("flickity-resize");
    };

    Flickity.createMethods.push("_createResizeClass");

    var resize = Flickity.prototype.resize;
    Flickity.prototype.resize = function () {
      this.element.classList.remove("flickity-resize");
      resize.call(this);
      this.element.classList.add("flickity-resize");
    };
  }

  fetchProducts() {
    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("product-recommendations");

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;

          if (this.parent) {
            this.parent.classList.add("product-recommendations--full");

            if (document.body.classList.contains("open-cart")) {
              this.parent.classList.add("active");
            }
          }
        }

        this.classList.add("product-recommendations--loaded");
        window.Currency?.convertAll?.();

        this.cartCarousel = this.querySelector(".recommendations-carousel");
        if (this.cartCarousel) {
          this.recommendationsCarousel = new Flickity(this.cartCarousel, {
            imagesLoaded: true,
            contain: true,
            prevNextButtons: false,
            pageDots: false,
            watchCSS: true,
            cellAlign: "left",
          });

          setTimeout(() => {
            this.recommendationsCarousel.resize();
          }, 300);
        }

        let _this = this;
        this.fetchedCarousel = this.querySelector(".fetched-carousel");
        if (this.fetchedCarousel) {
          let slideshow_slides = Array.from(
              this.fetchedCarousel.querySelectorAll(".carousel__slide"),
            ),
            autoplay =
              this.fetchedCarousel.dataset.autoplay == "false"
                ? false
                : parseInt(this.fetchedCarousel.dataset.autoplay, 10),
            align =
              this.fetchedCarousel.dataset.align == "center"
                ? "center"
                : "left",
            fade = this.fetchedCarousel.dataset.fade == "true" ? true : false,
            prev_button = this.fetchedCarousel.querySelector(".flickity-prev"),
            next_button = this.fetchedCarousel.querySelector(".flickity-next"),
            progress_bar = this.fetchedCarousel.parentNode.querySelector(
              ".flickity-progress--bar",
            ),
            rightToLeft = document.dir === "rtl",
            selectedIndex = 0,
            args = {
              wrapAround: false,
              cellAlign: align,
              pageDots: false,
              contain: true,
              fade: fade,
              autoPlay: autoplay,
              rightToLeft: rightToLeft,
              prevNextButtons: false,
              cellSelector: ".carousel__slide",
              on: {
                ready() {
                  if (prev_button) {
                    prev_button.classList.add("disabled");
                  }
                },
                change() {
                  const slideWidth = this.slides[0].outerWidth;
                  const carouselWidth = this.element.offsetWidth;
                  const visibleSlides = Math.floor(carouselWidth / slideWidth);
                  if (this.selectedIndex === 0) {
                    prev_button.classList.add("disabled");
                    next_button.classList.remove("disabled");
                  } else if (
                    this.selectedIndex >=
                    this.slides.length - visibleSlides
                  ) {
                    prev_button.classList.remove("disabled");
                    next_button.classList.add("disabled");
                  } else {
                    prev_button.classList.remove("disabled");
                    next_button.classList.remove("disabled");
                  }
                },
              },
            };

          if (slideshow_slides.length < 1) {
            return;
          }

          if (progress_bar) {
            args.wrapAround = false;
            args.on.scroll = function (progress) {
              progress = Math.max(0, Math.min(1, progress));

              progress_bar.style.width = progress * 100 + "%";
            };
          }
          this.flkty = new Flickity(this.fetchedCarousel, args);

          selectedIndex = this.flkty.selectedIndex;

          this.fetchedCarousel.dataset.initiated = true;

          if (prev_button) {
            prev_button.addEventListener("click", (event) => {
              this.flkty.previous();
            });
            prev_button.addEventListener("keyup", (event) => {
              this.flkty.previous();
            });
            next_button.addEventListener("click", (event) => {
              this.flkty.next();
            });
            next_button.addEventListener("keyup", (event) => {
              this.flkty.next();
            });
          }

          if (Shopify.designMode) {
            this.fetchedCarousel.addEventListener(
              "shopify:block:select",
              (event) => {
                let index = slideshow_slides.indexOf(event.target);
                this.flkty.select(index);
              },
            );
          }
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
  connectedCallback() {
    this.fetchProducts();

    document.addEventListener("cartChanged", () => {
      this.fetchProducts();
      if (this.recommendationsCarousel) {
        setTimeout(() => {
          this.recommendationsCarousel.resize();
        }, 300);
      }
    });

    document.addEventListener("cart-drawer:open", () => {
      if (this.recommendationsCarousel) {
        setTimeout(() => {
          this.recommendationsCarousel.resize();
        }, 300);
      }
    });

    document.addEventListener("wishlist:empty", () => {
      if (this.flkty) {
        setTimeout(() => {
          this.flkty.resize();
        }, 300);
      }
    });
  }
}

customElements.define("product-recommendations", ProductRecommendations);
